import React from "react";
import styles from "./custom-input.module.css";

const CustomInput = ({
  label,
  name,
  type,
  className,
  placeholder,
  onChange,
  readOnly,
  errorMessage,
  required,
  value,
  inputStyles,
  labelStyles,
}) => {
  return (
    <div className="form-group">
      {label && (
        <label
          htmlFor={name}
          className={styles.inputLabel}
          style={{ ...labelStyles }}
        >
          {label}
        </label>
      )}
      <input
        name={name}
        type={type}
        className={`form-control ${className}`}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        required={required}
        placeholder={placeholder}
        id={name}
        style={{ ...inputStyles }}
      />
      {errorMessage && <div className={``}>{errorMessage}</div>}
    </div>
  );
};

export default CustomInput;
